// CRITICAL: Fix title IMMEDIATELY before anything else
(function fixTitleImmediately() {
  try {
    const cached = localStorage.getItem('byd_admin_settings');
    if (cached) {
      const data = JSON.parse(cached);
      if (data.site_title) {
        document.title = data.site_title;
      }
    }
  } catch(e) {}
})();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
